import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import ErrorMessage from '@/components/common/ErrorMessage';
import FormButtons from '@/components/common/Form/FormButtons';
import FieldLayout from '@/components/Layout/FieldLayout';
import Layout from '@/components/Layout/Layout';
import FullPageLoader from '@/components/loader/FullPageLoader';
import BackButton from '@/components/ui/BackButton';
import Label from '@/components/ui/Label';
import PrimaryInput from '@/components/ui/PrimaryInput';
// import SearchSelectBox from '@/components/ui/SearchSelectBox';
import { ICompany } from '@/interfaces/company.model';
import { showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';

export interface IAddOfficeForm {
  name: string;
  companyId: string;
  address: string;
  lat: number;
  lng: number;
  range: string;
  iframe: string;
  biometricId: string;
  isPunchAllowed: boolean;
}
interface IAddOfficeResponse {
  status: boolean;
  message: string;
  data: { company: ICompany[] };
}
export interface IMap {
  lat: number;
  lng: number;
}
const AddOffice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [companyList, setCompanyList] = useState<ICompany[]>([]);
  // const [circleRadius, setCircleRadius] = useState<number>(0);
  // const [mapCenter, setMapCenter] = useState<IMap | null>(null);
  // const [marker, setMarker] = useState<IMap[]>([]);
  // const [isLoadingAddress, setIsLoadingAddress] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    // trigger,
    // control,
    formState: { errors },
  } = useForm<IAddOfficeForm>();
  useEffect(() => {
    getCompanyList();
  }, []);
  useEffect(() => {
    if (location?.state?.data && companyList?.length > 0) {
      const { data } = location.state;
      console.log(data)
      const locationData =
        typeof data?.location === 'string'
          ? JSON.parse(data.location)
          : data.location;
      console.log(location);
      const latitude = parseFloat(locationData?.lat);
      const longitude = parseFloat(locationData?.lng);

      reset({
        name: data?.name || '',
        companyId: data?.companyId || '',
        address: data?.address || '',
        range: data?.range || '',
        lat: latitude || 0,
        lng: longitude || 0,
        isPunchAllowed: String(data?.isPunchAllowed) as unknown as boolean,
      });
    }
  }, [location, companyList]);
  const getCompanyList = async () => {
    try {
      const API = `${API_URL}${API_ENDPOINT?.getCompany}`;
      const response: IAddOfficeResponse = await callApi(API, {
        method: 'GET',
      });
      if (response.status === true) {
        setCompanyList(response?.data?.company);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getCoordintes = async (iframeValue: string) => {
    const latAndlong = extractLatLngFromIframe(iframeValue);
    if (latAndlong) {
      setValue('lat', latAndlong.lat);
      setValue('lng', latAndlong.lng);
    }
  };
  const extractLatLngFromIframe = (iframeString: string) => {
    const regex = /!2d([-.\d]+)!3d([-.\d]+)/;
    const match = iframeString.match(regex);
    if (match) {
      const longitude = parseFloat(match[1]);
      const latitude = parseFloat(match[2]);
      return { lat: latitude, lng: longitude };
    }
    return null;
  };
  const onSubmit: SubmitHandler<IAddOfficeForm> = async (data) => {
    try {
      const cords = {
        lat: data?.lat,
        lng: data?.lng,
      };
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        const dataKey = key as keyof IAddOfficeForm;
        const value = data[dataKey];
        if (dataKey == 'iframe') return;
        if (value !== null && value !== undefined && value !== '') {
          formData.append(key, String(value));
        }
      });
      formData.append('location', JSON.stringify(cords));
      if (!location?.state?.data) {
        formData.append('type', 'office');
      }
      if (location?.state?.data) {
        const API = `${API_URL}${API_ENDPOINT?.updateSite}?siteId=${location?.state?.data?.id}`;
        setIsLoading(true);
        const response: IAddOfficeResponse = await callApi(API, {
          method: 'POST',
          data: formData,
          multipart: true,
        });

        if (response?.status === true) {
          showToastNotification('success', response?.message);
          navigate(-1);
        } else {
          showToastNotification('danger', response?.message);
        }
      } else {
        const API = `${API_URL}${API_ENDPOINT?.addSite}`;
        setIsLoading(true);
        const response: IAddOfficeResponse = await callApi(API, {
          method: 'POST',
          data: formData,
          multipart: true,
        });
        if (response?.status) {
          showToastNotification('success', response?.message);
          navigate(-1);
        } else {
          showToastNotification('danger', response?.message);
        }
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };
  // useEffect(() => {
  //   navigator.geolocation.getCurrentPosition((position) => {
  //     reset((prev) => ({
  //       ...prev,
  //       lat: position.coords.latitude,
  //       lng: position.coords.longitude,
  //     }));
  //   });
  // }, []);

  // const getBiometric = async () => {
  //   return [];
  // };
  return (
    <>
      <Layout>
        {isLoading ? (
          <FullPageLoader />
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row align-items-center row-gap-3">
              <BackButton isEdit={location?.state?.data} label={` Office`} />
              <div className="card">
                <div className="card-body">
                  {/* <div className="col-12 mb-4">
                    <h4>Office Location</h4> */}

                  {/* <div className="embed-map-responsive">
                    <div className="embed-map-container"> */}
                  {/* <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3522.843218646283!2d73.33193707479816!3d27.998692712582546!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393fe7d975c3538d%3A0x108caced74d7c3d0!2siWebwiser!5e0!3m2!1sen!2sin!4v1763376475479!5m2!1sen!2sin"
                        width="600"
                        height="450"
                        loading="lazy"
                      /> */}
                  {/* <iframe
                        key={`${watch('lat')}-${watch('lng')}`}
                        src={`https://www.google.com/maps?q=${watch('lat')},${watch('lat')}&z=${watch('range')}&hl=en&output=embed`}
                        width="600"
                        height="450"
                        loading="lazy"
                        title="Office location"
                      /> */}

                  {/* <iframe
                        key={`${watch('lat')}-${watch('lng')}`}
                        className="embed-map-frame"
                        src={`https://www.google.com/maps?q=${watch('lat')},${watch('lng')}&hl=en&z=${watch('range')}&output=embed`}
                        allowFullScreen
                        loading="lazy"
                        title="Office location"
                      /> */}
                  {/* </div>
                  </div> */}
                  {/* </div> */}

                  <div className="col-12">
                    <div className="row">
                      <FieldLayout fieldStyle="col-12 col-lg-6">
                        <PrimaryInput
                          type="text"
                          id="cardId"
                          label="Office Name"
                          placeholder="Enter office name"
                          errors={errors?.name?.message}
                          {...register('name', {
                            ...errorTypes.required(),
                            ...errorTypes.name,
                          })}
                        />
                      </FieldLayout>
                      <FieldLayout fieldStyle="col-12 col-lg-6">
                        <Label id="form-label">Company</Label>
                        <select
                          key={watch('companyId')}
                          className="form-select form-control"
                          {...register('companyId', {
                            required: 'Please select a company',
                          })}
                        >
                          <option value="" className="d-none">
                            Select Company
                          </option>
                          {companyList?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                        <ErrorMessage message={errors?.companyId?.message} />
                      </FieldLayout>
                      {/* <FieldLayout fieldStyle="col-12 col-lg-6">
                          <Label required={true} id="biometricId">
                            Biometric
                          </Label>
                          <Controller
                            control={control}
                            name="biometricId"
                            rules={errorTypes.required('Biometric')}
                            render={({ field }) => (
                              <SearchSelectBox
                                value={field.value}
                                title="Select biometric"
                                onChange={(option) =>
                                  field.onChange(option?.value || '')
                                }
                                isAsync
                                fetchOptions={getBiometric}
                                defaultFetch
                                disable={isLoading}
                                isUsingFilter
                              />
                            )}
                          />
                          <ErrorMessage
                            message={errors?.biometricId?.message}
                          />
                        </FieldLayout> */}
                      <FieldLayout fieldStyle="col-12 col-lg-6">
                        <PrimaryInput
                          type="text"
                          id="description"
                          placeholder="Enter address"
                          label="Address"
                          errors={errors?.address?.message}
                          {...register('address', {
                            required: 'This field is Required',
                          })}
                        />
                      </FieldLayout>
                      <FieldLayout fieldStyle="col-12 col-lg-6">
                        <PrimaryInput
                          type="text"
                          id="description"
                          placeholder="Enter iframe"
                          label="Iframe"
                          errors={errors?.iframe?.message}
                          // defaultValue={''}
                          {...register('iframe', {
                            required: !location?.state?.data
                              ? 'This field is required'
                              : false,
                            onChange: (e) => getCoordintes(e.target.value),
                          })}
                        />
                      </FieldLayout>
                    </div>

                    {/* <div className="col-12 col-md-6 col-lg-3 mt-5">
                        <button
                          className="btn btn-primary w-auto"
                          type="button"
                          onClick={getCoordintes}
                        >
                          <LocationIcon />{' '}
                          {isLoadingAddress ? <Spinner /> : 'Get Coordinates'}
                        </button>
                      </div> */}

                    <div className="row">
                      <div className="col-12 col-md-6 col-lg-6">
                        <div className="form-group mb-3">
                          <PrimaryInput
                            type="number"
                            id="number"
                            errors={errors?.lat?.message}
                            label="Latitude"
                            disabled
                            value={
                              watch('lat')
                                ? Number(watch('lat')).toFixed(4)
                                : ''
                            }
                            {...register('lat', {
                              required: 'This field is Required',
                              setValueAs: (value) => Number(value).toFixed(4),
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-6">
                        <div className="form-group mb-3">
                          <PrimaryInput
                            type="number"
                            id="lng"
                            errors={errors?.lng?.message}
                            label="Longitude"
                            disabled
                            value={
                              watch('lng')
                                ? Number(watch('lng')).toFixed(4)
                                : ''
                            }
                            {...register('lng', {
                              required: 'This field is Required',
                              setValueAs: (value) => Number(value).toFixed(4), // Ensure saved value is fixed to 4 decimals
                            })}
                          />
                        </div>
                      </div>
                      <FieldLayout fieldStyle="col-12 col-lg-6">
                        <PrimaryInput
                          type="text"
                          inputMode="numeric"
                          id="range"
                          errors={errors?.range?.message}
                          placeholder="Enter range"
                          label="Range (in mtr)"
                          min={1}
                          onInput={(e) => {
                            e.currentTarget.value =
                              e.currentTarget.value.replace(/\D/g, '');
                          }}
                          {...register('range', {
                            required: 'This field is Required',
                            valueAsNumber: true,
                          })}
                        // onChange={(e) => {
                        //   const newRange = Number(e.target.value);
                        //   setCircleRadius(newRange);
                        // }}
                        />
                      </FieldLayout>
                      <FieldLayout fieldStyle="col-12 col-md-6 col-lg-6">
                        <Label id="punchAllowed">Web Check-In</Label>
                        <select
                          className="form-select form-control"
                          defaultValue={''}
                          {...register('isPunchAllowed', {
                            required: 'Please select a status',
                            setValueAs: (value) => {
                              if (value === 'true') return true;
                              if (value === 'false') return false;
                              return '';
                            },
                          })}
                        >
                          <option value="" className="d-none">
                            Select Status
                          </option>
                          <option value={"true"}>Yes</option>
                          <option value={"false"}>No</option>
                        </select>
                        <ErrorMessage message={errors?.isPunchAllowed?.message} />
                      </FieldLayout>
                    </div>
                  </div>
                </div>
                <FormButtons isLoading={isLoading} buttonStyle="gap-4 my-4">
                  {location?.state ? 'Update' : 'Add'}
                </FormButtons>
              </div>
            </div>
          </form>
        )}
      </Layout>
    </>
  );
};

export default AddOffice;
